import { Button, Column, Form, FormGroup, FormLabel, TextInput, Row } from "carbon-components-react"; // prettier-ignore
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchProcessingFee, updateProcessingFee } from "../../actions/processingfee"; // prettier-ignore
import { fetchProcessingFeeVendor, updateProcessingFeeVendor } from "../../actions/processingfeeVendor"; // prettier-ignore
import { LoadingIndicator } from "../../components";
import { getProcessingFeeData, getProcessingFeeIsFetching, getProcessingFeeVendorData, getProcessingFeeVendorIsFetching } from "../../selectors"; // prettier-ignore

const UpdateProcessingFeeForm = () => {
  const dispatch = useDispatch();

  const currentProcessingFee = useSelector(getProcessingFeeData);
  const currentProcessingFeeVendor = useSelector(getProcessingFeeVendorData);
  const processingFeeVendorDataIsFetching = useSelector(getProcessingFeeVendorIsFetching); // prettier-ignore
  const processingFeeDataIsFetching = useSelector(getProcessingFeeIsFetching);

  const [processingFee, setProcessingFee] = useState("");
  const [processingFeeVendor, setProcessingFeeVendor] = useState("");

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const processingFeeObject = {
      percentage: processingFee,
    };
    dispatch(updateProcessingFee(processingFeeObject));
    setProcessingFee("");
  };

  const handleFormSubmitVendor = (e) => {
    e.preventDefault();
    const processingFeeObject = {
      percentage: processingFeeVendor,
    };
    dispatch(updateProcessingFeeVendor(processingFeeObject));
    setProcessingFeeVendor("");
  };

  useEffect(() => {
    dispatch(fetchProcessingFee());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchProcessingFeeVendor());
  }, [dispatch]);

  return (
    <div style={{ backgroundColor: "#F5F5F5", padding: "10px", width: 400 }}>
      <h4>Update Processing Fees</h4>
      <LoadingIndicator active={processingFeeDataIsFetching} />
      <Form onSubmit={handleFormSubmit}>
        <FormGroup invalid={false} legendText="" message={false}>
          <Row>
            <Column>
              <TextInput
                id="percentage-updateprocessingfee"
                invalid={false}
                invalidText="A valid value is required"
                labelText="CYC Processing Fee %:"
                light={true}
                type="float"
                onChange={(e) => setProcessingFee(e.target.value)}
              />
            </Column>
            <Column>
              <FormLabel>Current %:</FormLabel>
              <p>{currentProcessingFee}%</p>
            </Column>
          </Row>
        </FormGroup>
        <Button kind="primary" type="submit">
          Update
        </Button>
      </Form>
      <br />
      <LoadingIndicator active={processingFeeVendorDataIsFetching} />
      <Form onSubmit={handleFormSubmitVendor}>
        <FormGroup invalid={false} legendText="" message={false}>
          <Row>
            <Column>
              <TextInput
                id="percentage-updateprocessingfeevendor"
                invalid={false}
                invalidText="A valid value is required"
                labelText="PayPal Processing Fee %:"
                light={true}
                type="float"
                onChange={(e) => setProcessingFeeVendor(e.target.value)}
              />
            </Column>
            <Column>
              <FormLabel>Current %:</FormLabel>
              <p>{currentProcessingFeeVendor}%</p>
            </Column>
          </Row>
        </FormGroup>
        <Button kind="primary" type="submit">
          Update
        </Button>
      </Form>
    </div>
  );
};

export default UpdateProcessingFeeForm;
